import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { Text, List, ListItem } from '@paygreen/paygreen-ui';
import IconByName from '../../../../utils/IconByName';
import { getStatusColorProps } from '../../../../utils/tools';
import { statusOptions } from '../../offsets/statusOptions';

const CarbonEmissionStatusList = ({ t }) => {
    const statusList = [
        'CREATED',
        'ONGOING',
        'PURCHASED',
        'CONTRIBUTED',
        'CLOSED',
    ];

    return (
        <List listStyle="icon">
            {statusList.map((status, index) => (
                <ListItem
                    key={index}
                    bulletStyle="icon"
                    bulletSize="xs"
                    marginTop={index === 0 ? 'sm' : 'none'}
                >
                    <IconByName
                        name={statusOptions[status].icon}
                        iconSize="sm"
                        marginTop="xs"
                        {...getStatusColorProps(statusOptions, status)}
                    />

                    <Text textSize="xs" colorWab="grey50">
                        <Trans
                            i18nKey={`offsets.explanationModal.status.${status}.statusNameMessage`}
                        >
                            <Text
                                htmlTag="strong"
                                textSize="xs"
                                {...getStatusColorProps(statusOptions, status)}
                            >
                                {{
                                    statusName: t(
                                        `offsets.explanationModal.status.${status}.statusName`,
                                    ),
                                }}
                            </Text>
                            ...
                        </Trans>
                    </Text>

                    {status === 'CONTRIBUTED' && (
                        <div>
                            <Text
                                textSize="xs"
                                colorWab="grey50"
                                htmlTag="span"
                            >
                                <Trans
                                    i18nKey={`offsets.explanationModal.status.OFFSET_FROM_ANOTHER_VENDOR.statusNameMessage`}
                                >
                                    ...
                                    <Text
                                        htmlTag="strong"
                                        textSize="xs"
                                        {...getStatusColorProps(
                                            statusOptions,
                                            status,
                                        )}
                                    >
                                        {{
                                            statusName: t(
                                                `offsets.explanationModal.status.OFFSET_FROM_ANOTHER_VENDOR.statusName`,
                                            ),
                                        }}
                                    </Text>
                                    ...
                                </Trans>
                            </Text>
                            <Text
                                textSize="xs"
                                colorWab="grey50"
                                htmlTag="span"
                            >
                                <Trans
                                    i18nKey={`offsets.explanationModal.status.OFFSET_FROM_A_CUSTOMER.statusNameMessage`}
                                >
                                    ...
                                    <Text
                                        htmlTag="strong"
                                        textSize="xs"
                                        {...getStatusColorProps(
                                            statusOptions,
                                            status,
                                        )}
                                    >
                                        {{
                                            statusName: t(
                                                `offsets.explanationModal.status.OFFSET_FROM_A_CUSTOMER.statusName`,
                                            ),
                                        }}
                                    </Text>
                                    ...
                                </Trans>
                            </Text>
                        </div>
                    )}
                </ListItem>
            ))}
        </List>
    );
};

export default withTranslation('common')(CarbonEmissionStatusList);
